import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useHistory} from 'react-router-dom';
import GoBackButton from "../layout/GoBackButton";
import {getSparePart} from "../../actions/spare_part";
import {Col, Nav, Row, Tab} from "react-bootstrap";
import SparePartAbout from "./tabs/SparePartAbout";
import SparePartImports from "./tabs/SparePartImports";
import SparePartExpenses from "./tabs/SparePartExpenses";
import SparePartSales from "./tabs/SparePartSales";

const SparePartPage = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    
    // Extract ID from URL path manually since we're not using :id route parameter
    const id = location.pathname.match(/\/spare-parts\/(\d+)/)?.[1];
    
    // Determine active tab from URL
    const getActiveTabFromUrl = () => {
        const path = location.pathname;
        if (path.includes('/imports')) return 'imports';
        if (path.includes('/expenses')) return 'expenses';
        if (path.includes('/sales')) return 'sales';
        return 'about';
    };
    
    const [activeTab, setActiveTab] = useState(getActiveTabFromUrl());

    useEffect(() => {
        if (id) {
            dispatch(getSparePart(id));
        }
    }, [dispatch, id]);
    
    useEffect(() => {
        setActiveTab(getActiveTabFromUrl());
    }, [location.pathname]);

    const {spare_part} = useSelector(state => state.spare_part);
    
    // Handle tab change and update URL
    const handleTabChange = (tabKey) => {
        setActiveTab(tabKey);
        
        // Update URL based on selected tab
        switch (tabKey) {
            case 'about':
                history.push(`/spare-parts/${id}`);
                break;
            case 'imports':
                history.push(`/spare-parts/${id}/imports`);
                break;
            case 'expenses':
                history.push(`/spare-parts/${id}/expenses`);
                break;
            case 'sales':
                history.push(`/spare-parts/${id}/sales`);
                break;
            default:
                history.push(`/spare-parts/${id}`);
        }
    };

    // If no ID is found in URL, show error
    if (!id) {
        return (
            <div className="alert alert-danger">
                Ehtiyot qism ID topilmadi. URL manzilni tekshiring.
            </div>
        );
    }

    return (
        <div>
            <main className="content mt-0 pt-0">
                <div className="container-fluid p-0">

                    <div className="row mb-2">
                        <div className="col-md-12 col-lg-8">
                            <h1 className="h3 mb-3">
                                {spare_part ? (
                                    <>
                                        <strong>{spare_part.name}</strong> - Ehtiyot qismi sahifasi
                                    </>
                                ) : (
                                    <><strong>Ehtiyot qismi</strong> sahifasi</>
                                )}
                            </h1>
                        </div>
                        <div className="col-lg-4">
                            <div className="crud_actions text-end">
                                <GoBackButton/>
                            </div>
                        </div>
                    </div>

                    {spare_part ? (
                        <div className="row">
                            <div className="col-md-12 col-lg-12">
                                <div className="card px-4 py-3">
                                    <Tab.Container id="spare-part-tabs" activeKey={activeTab} onSelect={handleTabChange}>
                                        <Row>
                                            <Col sm={3} md={3}>
                                                <Nav variant="pills" className="flex-column">
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="about"
                                                                  className="text-center fw-bold">Haqida</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="imports"
                                                                  className="text-center fw-bold">
                                                            Kirim
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="expenses"
                                                                  className="text-center fw-bold">
                                                            Chiqim
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="sales"
                                                                  className="text-center fw-bold">
                                                            Sotuv
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                            </Col>
                                            <Col sm={9} md={9}>
                                                <Tab.Content>
                                                    <Tab.Pane eventKey="about">
                                                        <SparePartAbout sparePart={spare_part}/>
                                                    </Tab.Pane>

                                                    <Tab.Pane eventKey="imports">
                                                        <SparePartImports />
                                                    </Tab.Pane>

                                                    <Tab.Pane eventKey="expenses">
                                                        <SparePartExpenses />
                                                    </Tab.Pane>

                                                    <Tab.Pane eventKey="sales">
                                                        <SparePartSales />
                                                    </Tab.Pane>
                                                </Tab.Content>
                                            </Col>
                                        </Row>
                                    </Tab.Container>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-md-12 col-lg-12">
                                <div className="card px-4 py-3">
                                    <div className="text-center">
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Yuklanmoqda...</span>
                                        </div>
                                        <p className="mt-2">Ehtiyot qismi ma'lumotlari yuklanmoqda...</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </main>
        </div>
    );
};

export default SparePartPage;